import { gql, useQuery } from "@apollo/client";
import { useClients } from "./useClients";

const GET_AOV_CR = gql`
  query publisherAovCr($publisherId: ID!) {
    publisherAovCr(publisherId: $publisherId) {
      aov
      cr
    }
  }
`;

export const useAovCr = (publisher) => {
  const { partnersClient } = useClients();

  return useQuery(GET_AOV_CR, {
    client: partnersClient,
    variables: {
      publisherId: publisher.publisherId,
    },
  });
};
